import React from 'react';

const About = () => {

    return (
        <div className="about-container">
            <div className="about-content">
                <h2>About This App</h2>
                <p>This mine sweeper style app was created by <a href="https://portfolio.sherilynvillareal.com">Sherilyn Villareal</a> as a coding challenge during the interview process of a spektacular company!</p>
            </div>
        </div>
    );
}

export default About;
